import * as ActionTypes from './actionTypes';
import get from 'lodash/get';

// -----------------------------------------------------
// Default State for Clients Tab as per new UX Design
// -----------------------------------------------------

const initialState = {
  bookOfBusiness: {
    clients: {
      summary: {},
      sortByValue: 'ClientName',
      filters: null,
      filtersQueryString: '',
      searchDetails: {
        searchBy: 'ClientName',
        value: '',
        isLoading: false,
        options: [],
      },
      pageNumber: 1,
      isLoading: false,
      isServiceError: false,
    },
  },
  rowSummary: {},
  clientsDashboard: null,
  clientsDashboardLoading: false,
  clientsDashboardError: false,
  autoSuggestResults: [],
};

const bObSummaryReducer = (state = initialState, action) => {
  const defaultBookOfBusiness = initialState.bookOfBusiness;
  const defaultClients = defaultBookOfBusiness.clients;
  const defaultSearchDetails = defaultClients.searchDetails;

  switch (action.type) {
    case ActionTypes.CLIENTS_SUMMARY_DASHBOARD:
      return { ...state, ...action.payload, clientsDashboard: action.payload.clientsDashboard };

    case ActionTypes.CLIENTS_SUMMARY_DASHBOARD_FETCH_FAILED:
      return { ...state, ...action.payload };

    case ActionTypes.CLICKED_ROW_SUMMARY:
      return { ...state, rowSummary: action.payload.rowSummary };

    case ActionTypes.AUTO_SUGGEST_SEARCH_SUCCESS:
    case ActionTypes.AUTO_SUGGEST_SEARCH_FAILED:
      return { ...state, autoSuggestResults: action.payload.autoSuggestResults };

    case ActionTypes.CLIENTS_SERVICE_ERROR:
      return {
        ...state,
        bookOfBusiness: {
          ...get(state.bookOfBusiness, defaultBookOfBusiness),
          clients: { ...get(state.bookOfBusiness, 'clients', defaultClients), isLoading: false, isServiceError: true },
        },
      };

    case ActionTypes.REQUEST_CLIENTS_DATA:
      return {
        ...state,
        bookOfBusiness: {
          ...get(state.bookOfBusiness, defaultBookOfBusiness),
          clients: { ...get(state.bookOfBusiness, 'clients', defaultClients), isLoading: true, isServiceError: false },
        },
      };

    case ActionTypes.RECEIVE_CLIENTS_DATA:
      return {
        ...state,
        bookOfBusiness: {
          ...get(state.bookOfBusiness, defaultBookOfBusiness),
          clients: {
            ...get(state.bookOfBusiness, 'clients', defaultClients),
            isLoading: false,
            isServiceError: false,
            summary: action.response,
          },
        },
      };

    case ActionTypes.CLIENTS_SET_PAGE_NUMBER:
      return {
        ...state,
        bookOfBusiness: {
          ...get(state.bookOfBusiness, defaultBookOfBusiness),
          clients: {
            ...get(state.bookOfBusiness, 'clients', defaultClients),
            pageNumber: action.pageNumber,
          },
        },
      };

    case ActionTypes.CONCAT_CLIENTS_DATA:
      return {
        ...state,
        bookOfBusiness: {
          ...get(state.bookOfBusiness, defaultBookOfBusiness),
          clients: {
            ...get(state.bookOfBusiness, 'clients', defaultClients),
            isLoading: false,
            isServiceError: false,
            summary: {
              ...action.response,
              bookOfBusiness: [
                ...get(state.bookOfBusiness, 'clients.summary.bookOfBusiness', []),
                ...action.response.bookOfBusiness,
              ],
            },
            pageNumber: action.pageNumber,
          },
        },
      };

    case ActionTypes.SET_CLIENTS_SEARCH_DETAILS:
      return {
        ...state,
        bookOfBusiness: {
          ...get(state.bookOfBusiness, defaultBookOfBusiness),
          clients: {
            ...get(state.bookOfBusiness, 'clients', defaultClients),
            searchDetails: {
              ...get(state.bookOfBusiness, 'clients.searchDetails', defaultSearchDetails),
              ...action.details,
            },
          },
        },
      };

    case ActionTypes.SET_CLIENTS_REST_PROPS:
      return {
        ...state,
        bookOfBusiness: {
          ...get(state.bookOfBusiness, defaultBookOfBusiness),
          clients: { ...get(state.bookOfBusiness, 'clients', defaultClients), ...action.details },
        },
      };

    default:
      return state;
  }
};

export default bObSummaryReducer;
